import { Component, Input } from '@angular/core';
import { ChatMessage } from 'src/app/store/samwin/chats/models/chat-message';
import { ChatParticipantType } from 'src/app/store/samwin/chats/models/chat-participant-type';

@Component({
   selector: 'samweb-chat-message',
   templateUrl: './chat-message.component.html',
   styleUrls: ['./chat-message.component.scss'],
})
export class ChatMessageComponent {
   @Input()
   public message: ChatMessage;

   public get chatParticipantType(): typeof ChatParticipantType {
      return ChatParticipantType;
   }
}
